import React, { useEffect, useReducer, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  LinearProgress,
  Grid,
  Stack,
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  DialogContent,
  Divider,
  SvgIcon,
  Tab,
  Tabs,
  IconButton,
} from "@mui/material";
import ReactECharts from "echarts-for-react";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import CheckIcon from "@mui/icons-material/Check";
import SportsScoreIcon from "@mui/icons-material/SportsScore";
import TimerIcon from "@mui/icons-material/Timer";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import StarIcon from "@mui/icons-material/Star";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import RemoveIcon from "@mui/icons-material/Remove";
import { listPerformance } from "../../Redux/Slices/NewDashboardAPI/ListPerformanceSlice";
import {
  addCreategoals,
  clearAddCreategoalsResponse,
} from "../../Redux/Slices/NewDashboardAPI/AddCreategoalsSlice";
import ButtonField from "../../Components/Button/ButtonField";
import { ReactComponent as award } from "./ImageforDashboardStudent/award.svg";
import { ReactComponent as trend } from "./ImageforDashboardStudent/trend-up.svg";
import { ReactComponent as trophy } from "./ImageforDashboardStudent/trophy.svg";
import { ReactComponent as star } from "./ImageforDashboardStudent/star.svg";
import StudyStreakCard from "./StudyStreakCard";
import DashboardUserCalender from "./Study_Progress/DashboardUserCalender";
import { TabPanel } from "@mui/lab";
import Achievements from "./Achievements";
import CloseIcon from "@mui/icons-material/Close";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import { z } from "zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const achievements = [
  { label: "First Mock", icon: "🎯" },
  { label: "Speed Master", icon: "⏱️" },
  {
    label: "Top Scorer",
    icon: <SvgIcon component={trophy} sx={{ fontSize: 22, fill: "white" }} />,
  },
  {
    label: "Perfect Quiz",
    icon: <SvgIcon component={star} sx={{ fontSize: 22, color: "white" }} />,
  },
];

export interface Goals {
  daily_goal?: number;
  questions_attempted_today?: number;
  acheived?: boolean;
  goal_active_days?: number;
  days?: number;
}

const Performanceattandcard = () => {
  const { data: listListPerformanceSlice } = useAppSelector(
    (state) => state.ListPerformanceSlice
  );
  const { data: DailygoalsSlice } = useAppSelector(
    (state) => state.ListDailygoalsSlice
  );

  const { data: addGoals } = useAppSelector(
    (state) => state.AddCreategoalsSlice
  );
  const Dailygoal: any = DailygoalsSlice?.data;
  const [selectedPeriod, setSelectedPeriod] = useState<"all" | "7_days">("all");
  const [tabValue, setTabValue] = useState(0);
  const ListPerformanceSlice: any[] = (
    listListPerformanceSlice?.data ?? []
  ).map((user: any, index: number) => ({
    ...user,
    index: index + 1,
  }));

  const dispatch = useAppDispatch();

  const xAxisData = ListPerformanceSlice?.map(
    (item) => item?.questiontype_name?.split(" ")[0] || ""
  );

  const accuracyData = ListPerformanceSlice?.map(
    (item) => item?.accuracy_percentage
  );

  const isMobile = window.innerWidth < 600;

  const barChartOptions = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      backgroundColor: "#fff",
      borderColor: "#e0e0e0",
      borderWidth: 1,
      textStyle: {
        color: "#009dff",
        fontWeight: 600,
        fontSize: 16,
      },
      formatter: (params: any) => {
        const p = params[0];
        return `<span style="color:#009dff;font-weight:500;font-size:15px">${p.name}: ${p.value}%</span>`;
      },
      extraCssText: "box-shadow: 0 2px 8px rgba(0,0,0,0.08);",
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLine: { lineStyle: { color: "#888" } },
      axisTick: { show: false },
      axisLabel: {
        fontSize: 15,
        color: "#222",
        fontWeight: 500,
        margin: 12,
      },
      axisPointer: {
        type: "shadow",
        shadowStyle: {
          color: "rgba(44, 44, 44, 0.35)", // gray highlight, adjust opacity as needed
        },
        z: 1,
      },
    },
    yAxis: {
      type: "value",
      axisLabel: { formatter: "{value}%", color: "#888", fontSize: 13 },
      splitLine: {
        show: true,
        lineStyle: {
          type: "dashed",
          color: "#e0e0e0",
        },
      },
      max: 100,
      axisLine: { show: false },
      axisTick: { show: false },
    },
    series: [
      {
        name: "Accuracy",
        type: "bar",
        data: accuracyData,
        barWidth: "20%", // responsive value here
        itemStyle: {
          color: "#009dff",
          borderRadius: [4, 4, 0, 0],
          shadowColor: "rgba(0, 165, 255, 0.08)",
          shadowBlur: 8,
        },
        emphasis: {
          itemStyle: {
            color: "#0074CC",
            shadowColor: "rgba(0, 115, 204, 0.35)", // much darker shadow
            shadowBlur: 24, // stronger blur for more prominent shadow
            borderRadius: [4, 4, 0, 0],
          },
        },
        z: 10,
      },
    ],
    grid: { top: 10, bottom: 30, left: 50, right: 10 },
    animationDuration: 700,
  };

  // popup message

  const [open, setOpen] = useState(false);
  const [dailyQuestionGoal, setDailyQuestionGoal] = useState<number | null>(
    null
  );
  const [streakGoalDays, setStreakGoalDays] = useState<number | null>(null);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  const { data: goalValues } = useAppSelector(
    (state) => state.ListDailygoalsSlice
  );

  const goalSchema = z.object({
    daily_goal: z
      .number()
      .min(1, { message: "Daily question goal must be minimum 1" }),
    days: z.number().min(1, { message: "Streak goal must be minimum 1" }),
  });

  const methods = useForm<Goals>({
    defaultValues: {
      daily_goal: goalValues?.data?.daily_goal,
      days: goalValues?.data?.days,
    },
    resolver: zodResolver(goalSchema),
  });

  useEffect(() => {
    if (goalValues?.data) {
      methods.reset({
        daily_goal: goalValues.data.daily_goal,
        days: goalValues.data.days,
      });
    }
  }, [goalValues, methods]);

  console.log("the value goals", goalValues?.data);
  console.log("methods value", methods.getValues());

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // clear input on cancel
    setDailyQuestionGoal(null);
    setStreakGoalDays(null);
  };

  const handleSubmit = () => {};

  const onSubmit: SubmitHandler<Goals> = (val) => {
    console.log("the submit value", val);
    dispatch(
      addCreategoals({
        daily_goals: Number(dailyQuestionGoal),
        days: Number(streakGoalDays),
      })
    );
    handleClose();
  };
  useEffect(() => {
    return () => {
      dispatch(clearAddCreategoalsResponse());
    };
  }, []);

  const attempted = Dailygoal?.questions_attempted_today ?? 0;
  const goal = Dailygoal?.daily_goal ?? 1;
  const totalDots = 5;
  const filledDots = Math.round((attempted / goal) * totalDots);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          marginTop: "20px",
        }}
      >
        <Grid container spacing={2}>
          {/* Left Panel */}
          <Grid
            xs={12}
            sm={12}
            md={12}
            lg={9}
            sx={{ paddingLeft: "16px", paddingTop: "16px" }}
            className="study-process-left"
          >
            <Card
              sx={{
                p: 2,
                boxShadow: "0px 2px 12px rgba(0,0,0,0.05)",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
                width={"100%"}
              >
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ fontSize: "19px" }}
                >
                  Performance by Subject
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Button
                    variant={selectedPeriod === "all" ? "contained" : "text"}
                    size="small"
                    sx={{
                      backgroundColor:
                        selectedPeriod === "all" ? "#009dff" : "#fff",
                      color: selectedPeriod === "all" ? "white" : "black",
                      fontSize: "13px",
                      textTransform: "capitalize",
                      border:
                        selectedPeriod === "all" ? "none" : "1px solid #dcdcdc",
                      "&:hover": {
                        backgroundColor:
                          selectedPeriod === "all" ? "#009dff" : "#f0f0f0",
                      },
                    }}
                    onClick={() => {
                      setSelectedPeriod("all");
                      dispatch(listPerformance({ period: null }));
                    }}
                  >
                    All Time
                  </Button>
                  <Button
                    variant={selectedPeriod === "7_days" ? "contained" : "text"}
                    size="small"
                    sx={{
                      backgroundColor:
                        selectedPeriod === "7_days" ? "#009dff" : "#fff",
                      color: selectedPeriod === "7_days" ? "white" : "black",
                      fontSize: "13px",
                      textTransform: "capitalize",
                      border:
                        selectedPeriod === "7_days"
                          ? "none"
                          : "1px solid #dcdcdc",
                      "&:hover": {
                        backgroundColor:
                          selectedPeriod === "7_days" ? "#009dff" : "#f0f0f0",
                      },
                    }}
                    onClick={() => {
                      setSelectedPeriod("7_days");
                      dispatch(listPerformance({ period: "7_days" }));
                    }}
                  >
                    Last 7 Days
                  </Button>
                </Stack>
              </Box>
              <ReactECharts
                option={barChartOptions}
                style={{ height: "250px" }}
              />
              <Box mt={2}>
                <Grid container>
                  <Grid
                    item
                    xs={6}
                    sx={{
                      backgroundColor: "#f9fafb",

                      padding: "12px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#374151",
                      }}
                    >
                      Subject
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{
                      backgroundColor: "#f9fafb",
                      padding: "12px",
                      textAlign: "end",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#374151",
                      }}
                    >
                      Accuracy
                    </Typography>
                  </Grid>
                </Grid>
                {ListPerformanceSlice?.map((sub) => (
                  <Grid container key={sub.name} sx={{ py: 0.5 }}>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        padding: "5px",
                      }}
                    >
                      <Typography sx={{ fontSize: "12px", fontWeight: 400 }}>
                        {sub.questiontype_name?.split(" ")[0] || ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        color={
                          sub.accuracy_percentage >= 75
                            ? "green"
                            : sub.accuracy_percentage >= 50
                            ? "#b57f00"
                            : "#ef4444"
                        }
                        sx={{
                          padding: "5px",
                          textAlign: "end",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {sub.accuracy_percentage}%{" "}
                        {sub.accuracy_percentage >= 75 ? (
                          <ArrowUpwardIcon fontSize="small" />
                        ) : sub.accuracy_percentage >= 50 ? (
                          <ArrowDownwardIcon fontSize="small" />
                        ) : (
                          <RemoveIcon fontSize="small" />
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Box>
            </Card>
          </Grid>

          {/* Right Panel */}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={3}
            className="study-process-right"
          >
            {/* Tab Options for Right Panel */}
            <Card
              sx={{ p: "20px", boxShadow: "0px 2px 12px rgba(0,0,0,0.05)" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignitem: "center",
                }}
              >
                <div>
                  <Typography
                    sx={{
                      fontSize: "19px",
                      fontWeight: "700",
                    }}
                  >
                    Study Progress
                  </Typography>
                </div>
                <div>
                  <IconButton onClick={handleOpen}>
                    <SettingsIcon />
                  </IconButton>
                </div>
              </Box>
              <Box mt={"20px"}>
                <Tabs
                  value={tabValue}
                  onChange={(_, newValue) => setTabValue(newValue)}
                  aria-label="dashboard tabs"
                  variant="fullWidth"
                  TabIndicatorProps={{ style: { display: "none" } }}
                  sx={{
                    "& .MuiTab-root": {
                      fontSize: "14px",
                      borderRadius: "6px",
                      textTransform: "capitalize",
                      minHeight: "36px", // reduce height
                      minWidth: "80px", // reduce width
                      padding: "0px 12px", // less padding
                      color: "black",
                      fontWeight: "500",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#009DFF",
                      color: "white !important",
                      fontWeight: "500",
                    },
                  }}
                >
                  <Tab label="Calendar" />
                  <Tab label="Streak" />
                  <Tab label="Achievements" />
                </Tabs>

                {tabValue === 0 && (
                  <Box sx={{ mt: 2 }}>
                    <DashboardUserCalender Dailygoal={Dailygoal} />
                  </Box>
                )}
                {tabValue === 1 && (
                  <Box>
                    <StudyStreakCard
                      Dailygoal={Dailygoal}
                      totalDots={totalDots}
                      filledDots={filledDots}
                      handleOpen={handleOpen}
                    />
                  </Box>
                )}
                {tabValue === 2 && (
                  <Box sx={{ mt: "4px", mb: "70px" }}>
                    <Achievements />
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: 400,
            borderRadius: "8px",
            boxShadow: "0 8px 32px rgba(0,173,255,0.15)",
            // background: "linear-gradient(135deg, #f4fafe 80%, #e0f7ff 100%)",
            background: "#ffff",
            p: 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "#020817",
            fontWeight: 600,
            fontSize: "18px",
            display: "flex",
            lineHeight: "18px",
            // alignItems: "center",
            gap: 1,
            justifyContent: "space-between",
            padding: "8px",
          }}
        >
          <span
            style={{
              fontWeight: 600,
              fontSize: "18px",
              lineHeight: "18px",
            }}
          >
            Update Goals
          </span>
          <SvgIcon
            component={CloseIcon}
            inheritViewBox
            onClick={handleClose}
            sx={{ cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "0 8px",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
            margin: "24px 0",
          }}
        >
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: "500",
                color: "#020817",
              }}
            >
              Daily Question Goal
            </span>
            <TextField
              type="number"
              name="daily_goal"
              // label="Daily Question Goal"
              fullWidth
              value={Number(methods?.getValues("daily_goal"))}
              onChange={(e) => {
                methods?.setValue("daily_goal", Number(e.target.value), {
                  shouldValidate: true,
                });
                forceUpdate();
              }}
              sx={{
                background: "#fff",
                borderRadius: 2,
                boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "8px 15px",
                },
                "& .MuiInputBase-root": { fontSize: "1.1rem" },
              }}
              InputProps={{
                sx: { borderRadius: 2 },
              }}
              error={!!methods.formState.errors.daily_goal}
              helperText={methods.formState.errors.daily_goal?.message}
            />
          </form>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: "500",
                color: "#020817",
              }}
            >
              Streak Goal (days)
            </span>
            <TextField
              type="number"
              name="days"
              // label="Streak Goal (days)"
              fullWidth
              value={methods.getValues("days") ?? ""}
              onChange={(e) => {
                methods.setValue("days", Number(e.target.value), {
                  shouldValidate: true,
                });
                forceUpdate();
              }}
              sx={{
                background: "#fff",
                borderRadius: 2,
                boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "8px 15px",
                },

                "& .MuiInputBase-root": { fontSize: "1.1rem" },
              }}
              InputProps={{
                sx: { borderRadius: 2 },
              }}
              error={!!methods.formState.errors.days}
              helperText={methods.formState.errors.days?.message}
            />
          </div>
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: "flex-end", pb: 2, display: "flex" }}
        >
          <ButtonField
            // className="form_cancel_button"
            onClick={handleClose}
            sx={{
              padding: "6px 14px",
              border: "1px solid #e5e7eb",
              color: "#020817",
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: "500",
              "&:hover": {
                background: "#16a249",
                color: "#ffff",
              },
            }}
          >
            Cancel
          </ButtonField>
          <ButtonField
            // className="form_save_button"
            onClick={methods.handleSubmit((val) => {
              console.log("the submit value", val);

              // Or use getValues() if you are not controlling fields with RHF state
              dispatch(
                addCreategoals({
                  daily_goals: Number(methods.getValues("daily_goal")),
                  days: Number(methods.getValues("days")),
                })
              );

              handleClose();
            })}
            // disabled={
            //   !methods.getValues("daily_goal") || !methods.getValues("days")
            // }
            sx={{
              // background: "linear-gradient(90deg, #00aaff 60%, #00e1ff 100%)",
              background: "#009dff",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              width: "auto",
              color: "#fff",
              padding: "6px 14px",
              boxShadow: "0 2px 8px rgba(0,173,255,0.08)",
              "&:hover": {
                // background: "linear-gradient(90deg, #0090dd 60%, #00bfff 100%)",
                background: "#129ef6ff",
              },
            }}
          >
            Update Goals
          </ButtonField>
        </DialogActions>
      </Dialog>
      <ResponseDialog response={addGoals} />
    </>
  );
};

export default Performanceattandcard;
